var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 4.5C14.9 4.5 17.5 6.2 18.7 8.7C18.9 9.2 18.4 9.7 18 9.4C16.7 8.8 14.5 7.9 12 7.9C9.5 7.9 7.3 8.8 6 9.4C5.5 9.6 5 9.1 5.3 8.7C6.5 6.2 9.1 4.5 12 4.5ZM10.4 18.9C10.4 19.1 10.2 19.3 10 19.2C7.5 18.5 5.5 16.5 4.8 14C4.7 13.8 4.9 13.6 5.1 13.6H5.2C8.1 13.6 10.4 15.9 10.4 18.9ZM12 14.1C10.9 14.1 9.9 13.2 9.9 12C9.9 10.8 10.8 9.9 12 9.9C13.2 9.9 14.1 10.8 14.1 12C14.1 13.2 13.1 14.1 12 14.1ZM14 19.2C13.8 19.3 13.6 19.1 13.6 18.9V18.8C13.6 15.9 15.9 13.6 18.8 13.6H18.9C19.1 13.6 19.3 13.8 19.2 14C18.5 16.5 16.5 18.5 14 19.2Z",
    fill: "#A1ABB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco8);
export default __webpack_public_path__ + "static/media/ico-8.fcbdd3910d935d4874ec4fb7c363ed43.svg";
export { ForwardRef as ReactComponent };